<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">REPORTES</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active"
        >INFORME MENSUAL Y GESTIÓN</span
      >
    </li>
  </ul>

  <div
    class="surface-section px-4 py-5 md:px-12 lg:px-12"
    style="border: 1px solid #000000"
  >
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>INFORME POR MES Y GESTIÓN</strong>
      </span>
    </div>

    <div class="col-12">
      <div class="p-fluid formgrid grid p-fondo">
        <div class="field col-12 md:col-3">
          <span><strong>SELECCIONE SUCURSAL: </strong></span>
          <div class="p-inputgroup">
            <Dropdown
              :disabled="true"
              v-model="sucursalSelected"
              :options="sucursales"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione una sucursal"
            />
          </div>
        </div>

        <div class="field col-12 md:col-3">
          <span><strong>SELECCIONE MES: </strong></span>
          <div class="p-inputgroup">
            <Dropdown
              v-model="mes_seleccionado"
              :options="meses"
              optionLabel="label"
              placeholder="Seleccione un mes"
            />
          </div>
        </div>

        <div class="field col-12 md:col-3">
          <span><strong>SELECCIONE AÑO: </strong></span>
          <div class="p-inputgroup">
            <InputNumber
              v-model="anio_gestion"
              :min="2021"
              :max="new Date().getFullYear()"
              :showButtons="true"
              mode="decimal"
              :useGrouping="false"
            />
          </div>
        </div>

        <div class="field col-12 md:col-3">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="APLICAR FILTROS"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Aplicar Filtros de Busqueda'"
            :loading="enviando"
            :disabled="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>

      <div class="p-fluid formgrid grid mt-2">
        <div class="field col-12">
          <div v-if="enviando" class="text-center">
            <ProgressSpinner />
          </div>
          <div
            v-if="
              semana1.length ||
              semana2.length ||
              semana3.length ||
              semana4.length ||
              semana5.length
            "
          >
            <div class="grid mt-4">
              <div class="col-12">
                <div class="card p-2">
                  <h3 class="estilo_resumen_titulo">
                    <i class="pi pi-tags mr-2"></i> Resumen Mensual de Productos
                    y Servicios
                  </h3>
                  <div class="grid">
                    <div class="col-12 md:col-6 lg:col-3">
                      <div class="card-total bg-blue-100">
                        <div class="flex align-items-center mb-1">
                          <div class="icon-left icon-blue">
                            <i class="pi pi-box text-xl"></i>
                          </div>
                          <div>
                            <span class="block text-500 font-medium text-sm"
                              >Cant. Productos</span
                            >
                            <div class="text-900 font-bold text-lg">
                              {{
                                sinDecimales(
                                  resumenMensualProdServ.total_cant_productos
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                      <div class="card-total bg-blue-100">
                        <div class="flex align-items-center mb-1">
                          <div class="icon-left icon-blue">
                            <i class="pi pi-dollar text-xl"></i>
                          </div>
                          <div>
                            <span class="block text-500 font-medium text-sm"
                              >Total Productos</span
                            >
                            <div class="text-900 font-bold text-lg">
                              Bs.
                              {{
                                convertirNumeroGermanicFormat(
                                  resumenMensualProdServ.total_productos
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                      <div class="card-total bg-orange-100">
                        <div class="flex align-items-center mb-1">
                          <div class="icon-left icon-orange">
                            <i class="pi pi-briefcase text-xl"></i>
                          </div>
                          <div>
                            <span class="block text-500 font-medium text-sm"
                              >Cant. Servicios</span
                            >
                            <div class="text-900 font-bold text-lg">
                              {{
                                sinDecimales(
                                  resumenMensualProdServ.total_cant_servicios
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                      <div class="card-total bg-orange-100">
                        <div class="flex align-items-center mb-1">
                          <div class="icon-left icon-orange">
                            <i class="pi pi-dollar text-xl"></i>
                          </div>
                          <div>
                            <span class="block text-500 font-medium text-sm"
                              >Total Servicios</span
                            >
                            <div class="text-900 font-bold text-lg">
                              Bs.
                              {{
                                convertirNumeroGermanicFormat(
                                  resumenMensualProdServ.total_servicios
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4">
                <div class="card p-2">
                  <h3 class="estilo_resumen_titulo">
                    <i class="pi pi-wallet mr-2"></i> Resumen Mensual de Caja
                  </h3>
                  <div class="grid">
                    <div class="col-12 md:col-6 lg:col-3">
                      <div class="card-total bg-green-100">
                        <div class="flex align-items-center mb-1">
                          <div class="icon-left icon-green">
                            <i class="pi pi-plus text-xl"></i>
                          </div>
                          <div>
                            <span class="block text-500 font-medium text-sm"
                              >Ingresos Totales</span
                            >
                            <div class="text-900 font-bold text-lg">
                              Bs.
                              {{
                                convertirNumeroGermanicFormat(
                                  resumenMensualCaja.total_ingresos_caja
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                      <div class="card-total bg-red-100">
                        <div class="flex align-items-center mb-1">
                          <div class="icon-left icon-red">
                            <i class="pi pi-minus text-xl"></i>
                          </div>
                          <div>
                            <span class="block text-500 font-medium text-sm"
                              >Egresos Totales</span
                            >
                            <div class="text-900 font-bold text-lg">
                              Bs.
                              {{
                                convertirNumeroGermanicFormat(
                                  resumenMensualCaja.total_egresos_mov_caja +
                                    resumenMensualCaja.total_comisiones +
                                    resumenMensualCaja.total_costos +
                                    resumenMensualCaja.total_compras
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3">
                      <div class="card-total bg-gray-100">
                        <div class="flex align-items-center mb-1">
                          <div class="icon-left icon-gray">
                            <i class="pi pi-wallet text-xl"></i>
                          </div>
                          <div>
                            <span class="block text-500 font-medium text-sm"
                              >Saldo Final del Mes</span
                            >
                            <div class="text-900 font-bold text-lg">
                              Bs.
                              {{
                                convertirNumeroGermanicFormat(
                                  resumenMensualCaja.total_dia
                                )
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <template
              v-for="(semana, index) in [
                semana1,
                semana2,
                semana3,
                semana4,
                semana5,
              ]"
              :key="index"
            >
              <div v-if="semana.length > 0" class="mb-4">
                <h3 class="estilo_dias">Semana {{ index + 1 }}</h3>
                <div class="table-responsive" style="overflow-x: auto">
                  <table class="table table-striped table-bordered">
                    <thead class="thead-dark">
                      <tr>
                        <th rowspan="2">Fecha</th>
                        <th colspan="3">Productos</th>
                        <th colspan="4">Servicios</th>
                        <th colspan="4">Caja</th>
                        <th rowspan="2">Compras</th>
                        <th rowspan="2">Total</th>
                      </tr>
                      <tr>
                        <th>Cant.</th>
                        <th v-tooltip.top="'Cant. x Precio'">Total Bs.</th>
                        <th v-tooltip.top="'Total / Cant.'">Prom. Bs.</th>
                        <th>Cant.</th>
                        <th v-tooltip.top="'Cant. x Precio'">Total Bs.</th>
                        <th v-tooltip.top="'(Cant. - Membresías) / Total'">
                          Prom. Bs.
                        </th>
                        <th>Membresías(0)</th>
                        <th>Ingresos</th>
                        <th>Egresos</th>
                        <th>Comisiones</th>
                        <th>Costos</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dato, idx) in semana" :key="idx">
                        <td>{{ formatFecha(dato.fecha) }}</td>
                        <td>{{ sinDecimales(dato.cant_productos) }}</td>
                        <td>
                          {{
                            convertirNumeroGermanicFormat(dato.total_productos)
                          }}
                        </td>
                        <td>
                          {{
                            getPromedioProductos(
                              dato.total_productos,
                              dato.cant_productos
                            )
                          }}
                        </td>
                        <td>{{ sinDecimales(dato.cant_servicios) }}</td>
                        <td>
                          {{
                            convertirNumeroGermanicFormat(dato.total_servicios)
                          }}
                        </td>
                        <td>
                          {{
                            getPromedioServicios(
                              dato.total_servicios,
                              dato.cant_servicios,
                              dato.cant_membresias
                            )
                          }}
                        </td>
                        <td>
                          {{ sinDecimales(dato.cant_membresias) }}
                        </td>
                        <td>
                          {{
                            convertirNumeroGermanicFormat(
                              dato.total_ingresos_caja
                            )
                          }}
                        </td>
                        <td>
                          {{
                            convertirNumeroGermanicFormat(
                              dato.total_egresos_mov_caja
                            )
                          }}
                        </td>
                        <td>
                          {{
                            convertirNumeroGermanicFormat(dato.total_comisiones)
                          }}
                        </td>
                        <td>
                          {{ convertirNumeroGermanicFormat(dato.total_costos) }}
                        </td>
                        <td>
                          {{
                            convertirNumeroGermanicFormat(dato.total_compras)
                          }}
                        </td>
                        <td>
                          {{ convertirNumeroGermanicFormat(dato.total_dia) }}
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td class="text-right"><strong>TOTALES</strong></td>
                        <td>
                          <strong>
                            {{
                              sinDecimales(
                                semana.reduce(
                                  (acc, item) => acc + item.cant_productos,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) => acc + item.total_productos,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td></td>
                        <td>
                          <strong>
                            {{
                              sinDecimales(
                                semana.reduce(
                                  (acc, item) => acc + item.cant_servicios,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) => acc + item.total_servicios,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td></td>
                        <td>
                          <strong>
                            {{
                              sinDecimales(
                                semana.reduce(
                                  (acc, item) => acc + item.cant_membresias,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) => acc + item.total_ingresos_caja,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) =>
                                    acc + item.total_egresos_mov_caja,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) => acc + item.total_comisiones,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) => acc + item.total_costos,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) => acc + item.total_compras,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              convertirNumeroGermanicFormat(
                                semana.reduce(
                                  (acc, item) => acc + item.total_dia,
                                  0
                                )
                              )
                            }}
                          </strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </template>
          </div>
          <div v-else class="text-center">
            <span
              style="
                color: red;
                font-size: 1.2rem;
                font-weight: bold;
                text-align: center;
              "
            >
              <i class="pi pi-info-circle"></i> Por favor, seleccione un mes y
              año para mostrar los datos.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VentaService from "@/service/VentaService";
import SucursalService from "@/service/SucursalService";
import { useAuth } from "@/stores";

export default {
  data() {
    return {
      enviando: false,
      sucursalSelected: 0,
      sucursales: [{ id: 0, nombre: "TODAS" }],
      meses: [
        { label: "ENERO", value: 1 },
        { label: "FEBRERO", value: 2 },
        { label: "MARZO", value: 3 },
        { label: "ABRIL", value: 4 },
        { label: "MAYO", value: 5 },
        { label: "JUNIO", value: 6 },
        { label: "JULIO", value: 7 },
        { label: "AGOSTO", value: 8 },
        { label: "SEPTIEMBRE", value: 9 },
        { label: "OCTUBRE", value: 10 },
        { label: "NOVIEMBRE", value: 11 },
        { label: "DICIEMBRE", value: 12 },
      ],
      mes_seleccionado: null,
      anio_gestion: new Date().getFullYear(),
      semana1: [],
      semana2: [],
      semana3: [],
      semana4: [],
      semana5: [],
      resumenMensualProdServ: {
        total_cant_productos: 0,
        total_productos: 0,
        promedio_productos: 0,
        total_cant_servicios: 0,
        total_servicios: 0,
        promedio_servicios: 0,
        total_cant_membresias: 0,
      },
      resumenMensualCaja: {
        total_ingresos_caja: 0,
        total_egresos_mov_caja: 0,
        total_comisiones: 0,
        total_costos: 0,
        total_compras: 0,
        total_dia: 0,
      },
    };
  },
  created() {
    this.ventaService = new VentaService();
    this.sucursalService = new SucursalService();
    this.auth = useAuth();
  },
  mounted() {
    this.cargarSucursales();
    this.mes_seleccionado = this.meses.find(
      (mes) => mes.value === new Date().getMonth() + 1
    );
  },
  methods: {
    getPromedioProductos(total, cantidad) {
      return cantidad > 0
        ? this.convertirNumeroGermanicFormat(total / cantidad)
        : 0;
    },

    getPromedioServicios(total, cantidad, membresias) {
      let cantidadTotal = cantidad - membresias;
      return cantidadTotal > 0
        ? this.convertirNumeroGermanicFormat(total / cantidadTotal)
        : 0;
    },
    BuscarFiltro() {
      this.semana1 = [];
      this.semana2 = [];
      this.semana3 = [];
      this.semana4 = [];
      this.semana5 = [];
      this.enviando = true;
      this.cargarReporteMensualGestion();
    },
    cargarReporteMensualGestion() {
      let datos = {
        sucursal_id: this.sucursalSelected,
        anio_gestion: this.anio_gestion,
        mes_seleccionado: this.mes_seleccionado.value,
      };
      this.ventaService
        .filtrarReporteMensualGestion(datos)
        .then((data) => {
          this.semana1 = data.datos.semana1 ?? [];
          this.semana2 = data.datos.semana2 ?? [];
          this.semana3 = data.datos.semana3 ?? [];
          this.semana4 = data.datos.semana4 ?? [];
          this.semana5 = data.datos.semana5 ?? [];
          this.resumenMensualProdServ = data.resumenMensualProdServ;
          this.resumenMensualCaja = data.resumenMensualCaja;
          this.enviando = false;
        })
        .catch((error) => {
          this.enviando = false;
          console.log(error);
        });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },
    sinDecimales(numero) {
      return (Math.round(numero * 10) / 10).toLocaleString("es-ES", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((data) => {
          data.forEach((sucursal) => {
            this.sucursales.push(sucursal);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatFecha(fecha) {
      const [year, month, day] = fecha.split("-");
      const localDate = new Date(year, month - 1, day);
      return new Intl.DateTimeFormat("es-ES", {
        dateStyle: "short",
      }).format(localDate);
    },
  },
};
</script>

<style scoped lang="scss">
.p-fondo {
  background-color: #7bffae;
  border: 1px solid #000000;
  border-bottom: 2px solid #000000;
}
.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
  padding: 1rem;
}

/* Nuevos estilos para los cards de totales */
.card-total {
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 8px; /* Un poco más suave */
  padding: 0.75rem 1rem; /* Más compacto */
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06); /* Sombra más sutil */
  cursor: pointer;
  margin-bottom: 0.5rem; /* Espacio entre cards */
  height: 100%; /* Asegura que todos tengan la misma altura si están en una fila */
  display: flex;
  align-items: center; /* Alinea contenido verticalmente */
}

.card-total:hover {
  transform: translateY(-3px) scale(1.01); /* Sutil elevación y zoom */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12); /* Sombra más notable al hover */
}

/* Línea de color a la izquierda */
.card-total::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px; /* Ancho de la línea, más discreto */
  border-radius: 8px 0 0 8px; /* Borde redondeado solo a la izquierda */
}

/* Colores de las líneas y texto de los iconos */
.card-total.bg-blue-100::before {
  background-color: #3b82f6;
}
.card-total.bg-orange-100::before {
  background-color: #f97316;
}
.card-total.bg-green-100::before {
  background-color: #22c55e;
}
.card-total.bg-red-100::before {
  background-color: #ef4444;
}
.card-total.bg-gray-100::before {
  background-color: #6b7280;
}

/* Estilo para el contenedor del icono a la izquierda */
.icon-left {
  margin-right: 0.75rem; /* Espacio entre el icono y el texto */
  padding: 0.25rem;
  border-radius: 50%; /* Mantener circular si se desea, aunque no tenga fondo */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; /* Evita que el icono se encoja */
}

/* Colores para los iconos */
.icon-blue {
  color: #3b82f6;
}
.icon-orange {
  color: #f97316;
}
.icon-green {
  color: #22c55e;
}
.icon-red {
  color: #ef4444;
}
.icon-gray {
  color: #6b7280;
}

/* Estilos de texto más pequeños para compactar */
.card-total .text-sm {
  font-size: 0.8rem; /* Tamaño de fuente más pequeño para las etiquetas */
}

.card-total .text-lg {
  font-size: 1.1rem; /* Tamaño de fuente para los valores numéricos */
}

.table-responsive {
  width: 100%;
  margin-top: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      text-align: center;
      vertical-align: middle;
      padding: 0.2rem;
      font-size: 1rem;
      border: 1px solid #ddd;
    }

    th {
      background-color: #002236;
      color: white;
      font-size: 1rem;
      font-weight: bold;
    }

    tbody tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    tbody tr:nth-child(odd) {
      background-color: #ffffff;
    }

    tfoot {
      font-weight: bold;
      background-color: #e9ecef;

      td {
        color: #002236;
      }
    }

    /* Colores por sección */
    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(4) {
      /* Productos */
      background-color: #e6f7ff;
      color: #007bff;
    }

    td:nth-child(5),
    td:nth-child(6),
    td:nth-child(7),
    td:nth-child(8) {
      /* Servicios */
      background-color: #fff3cd;
      color: #856404;
    }

    td:nth-child(9),
    td:nth-child(14) {
      /* Caja */
      background-color: #d4edda;
      color: #155724;
    }
    td:nth-child(10),
    td:nth-child(11),
    td:nth-child(12),
    td:nth-child(13) {
      /* Compras y Total */
      background-color: #f8d7da;
      color: #721c24;
    }
  }
}

/* Estilos para los títulos de las semanas */
.estilo_dias {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #002236;
  text-transform: uppercase;
  text-align: center;
}

/* Estilos para los títulos de los resúmenes */
.estilo_resumen_titulo {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #002236;
  text-align: left;
  border-bottom: 2px solid #005f91;
  padding-bottom: 0.5rem;
}

/* Estilos responsivos */
@media (max-width: 768px) {
  table {
    font-size: 0.8rem;

    th,
    td {
      padding: 0.5rem;
    }
  }

  .estilo_dias {
    font-size: 1.2rem;
  }
}
</style>
